import { getAsync } from "../httpServiceIntelafApi";

const URI = '/ultimaactualizacion';

export const getUltimaActualizacionInventarioAsync = () => {
    return getAsync(URI, {}).then((data) => { 
        return data; 
    });
}
